import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './Redux/store.js'
import API from './config/api';

// Log environment information for debugging
console.log('Running in environment:', import.meta.env.VITE_ENV);
console.log('API URL:', import.meta.env.VITE_API_URL);
console.log('API Version:', API.ENV);

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
)
